// src/components/featured-suppliers/featured-suppliers.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EgdsImageFragment on Image {\n    description\n    url\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment LandingFeaturedSupplierLogoFragment on LandingFeaturedSupplierLogo {\n    image {\n      ...EgdsImageFragment\n    }\n    url {\n      value\n    }\n    uisPrimeImpression {\n      referrerId\n      linkName\n    }\n    uisPrimeClick {\n      referrerId\n      linkName\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment LandingFeaturedSuppliersHeadingFragment on LandingFeaturedSuppliersHeading {\n    title {\n      text\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  query LandingFeaturedSuppliersQuery(\n    $context: ContextInput!\n    $uriContext: UriContextInput!\n    $maxSize: Int\n    $minSize: Int\n    $searchCriteria: LandingFeaturedSuppliersSearchCriteriaInput\n  ) {\n    landingFeaturedSuppliers(context: $context, uriContext: $uriContext, searchCriteria: $searchCriteria) {\n      heading {\n        ...LandingFeaturedSuppliersHeadingFragment\n      }\n      suppliers(maxSize: $maxSize, minSize: $minSize) {\n        ... on LandingFeaturedSupplierLogo {\n          ...LandingFeaturedSupplierLogoFragment\n        }\n      }\n      uisPrimeImpression {\n        referrerId\n        linkName\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/landing-featured-supplier-logo/landing-featured-supplier-logo.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType, UitkImageLink } from "@egds/react-core/images";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-media-item/egds-image.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkImage } from "uitk-react-images";
var fragment = gql(_templateObject());
var EgdsImage = function(param) {
    var data = param.data;
    var url = data.url, description = data.description;
    return /* @__PURE__ */ React.createElement(UitkImage, {
        alt: description,
        src: url
    });
};
EgdsImage.fragment = fragment;
EgdsImage.displayName = "EgdsImage";
// ../internal/src/components/landing-featured-supplier-logo/landing-featured-supplier-logo.tsx
var __fragment = gql2(_templateObject1(), EgdsImage.fragment);
var LandingFeaturedSupplierLogo = function(param) {
    var data = param.data;
    var image = data.image, url = data.url, uisPrimeImpression = data.uisPrimeImpression, uisPrimeClick = data.uisPrimeClick;
    var trackClick = useClickTracker();
    var onClickCapture = React2.useCallback(function() {
        var _uisPrimeClick_referrerId, _uisPrimeClick_linkName;
        trackClick((_uisPrimeClick_referrerId = uisPrimeClick === null || uisPrimeClick === void 0 ? void 0 : uisPrimeClick.referrerId) !== null && _uisPrimeClick_referrerId !== void 0 ? _uisPrimeClick_referrerId : "", (_uisPrimeClick_linkName = uisPrimeClick === null || uisPrimeClick === void 0 ? void 0 : uisPrimeClick.linkName) !== null && _uisPrimeClick_linkName !== void 0 ? _uisPrimeClick_linkName : "");
    }, [
        uisPrimeClick,
        trackClick
    ]);
    var handleKeyPress = function(event) {
        if (event.key === "Enter") {
            onClickCapture();
        }
    };
    if (!image.url) {
        return null;
    }
    var _uisPrimeImpression_referrerId, _uisPrimeImpression_linkName;
    return /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: (_uisPrimeImpression_referrerId = uisPrimeImpression === null || uisPrimeImpression === void 0 ? void 0 : uisPrimeImpression.referrerId) !== null && _uisPrimeImpression_referrerId !== void 0 ? _uisPrimeImpression_referrerId : "",
        linkName: (_uisPrimeImpression_linkName = uisPrimeImpression === null || uisPrimeImpression === void 0 ? void 0 : uisPrimeImpression.linkName) !== null && _uisPrimeImpression_linkName !== void 0 ? _uisPrimeImpression_linkName : ""
    }, url ? /* @__PURE__ */ React2.createElement(UitkFigure, {
        imageFit: "contain",
        ratio: UitkFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React2.createElement(EgdsImage, {
        data: image
    }), /* @__PURE__ */ React2.createElement(UitkImageLink, null, /* @__PURE__ */ React2.createElement("a", {
        href: url.value,
        target: "_blank",
        onClickCapture: onClickCapture,
        rel: "noopener"
    }, image.description && /* @__PURE__ */ React2.createElement("span", {
        className: "is-visually-hidden"
    }, image.description)))) : /* eslint-disable-next-line jsx-a11y/no-static-element-interactions*/ /* @__PURE__ */ React2.createElement("div", {
        onClickCapture: onClickCapture,
        onKeyPress: handleKeyPress
    }, /* @__PURE__ */ React2.createElement(UitkFigure, {
        imageFit: "contain",
        ratio: UitkFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React2.createElement(EgdsImage, {
        data: image
    }))));
};
LandingFeaturedSupplierLogo.displayName = "LandingFeaturedSupplierLogo";
LandingFeaturedSupplierLogo.fragment = __fragment;
// ../internal/src/components/landing-featured-suppliers-heading/landing-featured-suppliers-heading.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var __fragment2 = gql3(_templateObject2());
var LandingFeaturedSuppliersHeading = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React3.createElement(UitkHeading, {
        tag: "h2",
        size: 5
    }, data.title.text);
};
LandingFeaturedSuppliersHeading.fragment = __fragment2;
LandingFeaturedSuppliersHeading.displayName = "LandingFeaturedSuppliersHeading";
// src/components/featured-suppliers/featured-suppliers.tsx
import { defaultViewSizes, useMediaQueries, ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { Repeat, UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
var __Query = gql4(_templateObject3(), LandingFeaturedSupplierLogo.fragment, LandingFeaturedSuppliersHeading.fragment);
var FeaturedSuppliers = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var context = useBexApi().context;
    var viewPortSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var isMweb = viewPortSize === defaultViewSizes.SMALL;
    var isTablet = viewPortSize === defaultViewSizes.MEDIUM;
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: context,
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.landingFeaturedSuppliers)) {
        return null;
    }
    var _data_landingFeaturedSuppliers = data.landingFeaturedSuppliers, heading = _data_landingFeaturedSuppliers.heading, suppliers = _data_landingFeaturedSuppliers.suppliers, uisPrimeImpression = _data_landingFeaturedSuppliers.uisPrimeImpression;
    var featuredSuppliersAmount = suppliers.length;
    if (featuredSuppliersAmount < 1) {
        return null;
    }
    var maxLogoOnSmallView = Math.floor(featuredSuppliersAmount / 3) * 3;
    var suppliersTemplate = function(logos, columns, columnSpace, rowSpace) {
        return /* @__PURE__ */ React4.createElement(UitkSpacing, {
            margin: {
                blockstart: heading ? "four" : "unset"
            }
        }, /* @__PURE__ */ React4.createElement(UitkLayoutGrid, {
            justifyContent: "start",
            columns: [
                Repeat(columns, "1fr")
            ],
            space: {
                column: columnSpace,
                row: rowSpace
            }
        }, logos.map(function(logo, index) {
            var gridItem = /* @__PURE__ */ React4.createElement(UitkLayoutGridItem, {
                key: index
            }, /* @__PURE__ */ React4.createElement(UitkSpacing, null, /* @__PURE__ */ React4.createElement(LandingFeaturedSupplierLogo, {
                data: logo
            })));
            if (isMweb && (index < 3 || index < maxLogoOnSmallView)) {
                return gridItem;
            }
            if (isTablet && index < 6) {
                return gridItem;
            }
            if (!isMweb && !isTablet) {
                return gridItem;
            }
            return null;
        })));
    };
    var featuredSuppliersContent = /* @__PURE__ */ React4.createElement(React4.Fragment, null, heading && /* @__PURE__ */ React4.createElement(LandingFeaturedSuppliersHeading, {
        data: heading
    }), /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewLarge, null, /* @__PURE__ */ React4.createElement(React4.Fragment, null, suppliersTemplate(suppliers, 9, "four"))), /* @__PURE__ */ React4.createElement(ViewMedium, null, /* @__PURE__ */ React4.createElement(React4.Fragment, null, suppliersTemplate(suppliers, 6, "four"))), /* @__PURE__ */ React4.createElement(ViewSmall, null, /* @__PURE__ */ React4.createElement(React4.Fragment, null, suppliersTemplate(suppliers, 3, "four", "two")))));
    return (uisPrimeImpression === null || uisPrimeImpression === void 0 ? void 0 : uisPrimeImpression.linkName) && (uisPrimeImpression === null || uisPrimeImpression === void 0 ? void 0 : uisPrimeImpression.referrerId) ? /* @__PURE__ */ React4.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: uisPrimeImpression === null || uisPrimeImpression === void 0 ? void 0 : uisPrimeImpression.referrerId,
        linkName: uisPrimeImpression === null || uisPrimeImpression === void 0 ? void 0 : uisPrimeImpression.linkName
    }, featuredSuppliersContent) : featuredSuppliersContent;
};
FeaturedSuppliers.displayName = "sharedui-FeaturedSuppliers";
export { FeaturedSuppliers };
//# sourceMappingURL=index.js.map